import { ROLES } from "./roles";

export const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || null;
  } catch {
    return null;
  }
};

export const getHomeRoute = (user = readStoredUser()) => {
  const rights = user?.access_rights || [];
  const role = user?.role || localStorage.getItem("user_role");
  if (!role) return "/login";
  if (role === ROLES.ADMIN || user?.is_admin || user?.is_staff) return "/admin";
  if (role === ROLES.APPROVER) return "/approver";
  if (role === ROLES.FINANCE) return "/finance";
  if (role === ROLES.STORES) return "/stores";
  if (rights.includes("admin")) return "/admin";
  if (rights.includes("approve")) return "/approver";
  if (rights.includes("finance")) return "/finance";
  if (rights.includes("stores")) return "/stores";
  return "/requester";
};

export const hasRight = (user, right) => {
  const aliases = { request: "requester", approve: "approver" };
  return Boolean(user?.is_superuser || user?.access_rights?.includes(right) || user?.role === (aliases[right] || right));
};

export const isAuthenticated = () => Boolean(localStorage.getItem("access_token"));
